import { createAsyncThunk } from "@reduxjs/toolkit";
import { flexioServiceApi } from "./api";

export const getFlexioServiceList = createAsyncThunk(
  "get/flexio-services",
  async (params) => {
    return await flexioServiceApi.getList(params);
  }
);
